import { render } from "./HomeView.vue?vue&type=template&id=8791620c"
const script = {}

import exportComponent from "/builds/izee/leadservice/lead-admin-tool/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__